import React from 'react';

const Button = ({
  className,
  title,
  ...props
}: React.PropsWithRef<React.ButtonHTMLAttributes<HTMLButtonElement>>) => {
  const bg = props.disabled ? 'bg-gray-300' : 'bg-brand-forest';
  return (
    <button
      {...props}
      title={title}
      className={`${bg} text-white rounded block w-full p-4 mt-2 mb-4 ${className}`}
    >
      {title}
    </button>
  );
};

export default Button;
